import { motion } from "framer-motion";

interface ControlsProps {
  onPrev: () => void;
  onNext: () => void;
  isFirst: boolean;
  isLast: boolean;
  isChildTheme: boolean;
}

export function Controls({ onPrev, onNext, isFirst, isLast, isChildTheme }: ControlsProps) {
  return (
    <div className="flex items-center justify-between gap-4 px-4 py-3 bg-white/90 border-t border-slate-200 shrink-0">
      <motion.button
        type="button"
        onClick={onPrev}
        disabled={isFirst}
        className="flex items-center gap-2 px-4 py-2 rounded-full font-medium disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
        style={{ background: "var(--lp-nav-bg)", color: "var(--lp-nav-hover)" }}
        whileHover={isChildTheme && !isFirst ? { scale: 1.02 } : undefined}
        whileTap={isChildTheme ? { scale: 0.98 } : undefined}
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
        Back
      </motion.button>
      <motion.button
        type="button"
        onClick={onNext}
        className="flex items-center gap-2 px-5 py-2 rounded-full font-medium text-white transition-colors"
        style={{ background: "linear-gradient(90deg, var(--lp-header-from), var(--lp-header-to))" }}
        whileHover={isChildTheme ? { scale: 1.02 } : undefined}
        whileTap={isChildTheme ? { scale: 0.98 } : undefined}
      >
        {isLast ? "Finish" : "Next"}
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </motion.button>
    </div>
  );
}
